import React, { useState } from 'react'
import styled from 'styled-components'
import api from '@services/api'
import { useHistory } from 'react-router-dom'
import ConfirmModal from '@components/Modals/ConfirmModal'
import MessageModal from '@components/Modals/MessageModal'
import SubmitButton from '@components/Buttons/SubmitButton'

const texts = {
    disable: {
        btnText: 'חסום משתמש',
        confirmMainText: 'האם אתה בטוח שברצונך לחסום את המשתמש?',
    },
    restore: {
        btnText: 'התר חסימת משתמש',
        confirmMainText: 'האם אתה בטוח שברצונך להתיר את חסימת המשתמש?',
    },
}

export default ({ user }) => {
    const history = useHistory()
    const action = user.is_disabled ? 'restore' : 'disable'
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showDoneModal, setShowDoneModal] = useState(false)
    const [reason, setReason] = useState(null)
    //console.log('  reason = ', reason)

    const setUserIsDisabled = () => {
        //console.log('innnnnnnn')
        //console.log(' from  setUserIsDisabled   reason = ', reason)
        setShowConfirmModal(false)
        const newUser = Object.assign({}, user, {
            is_disabled: !user.is_disabled,
        })
        let NewUserWithDisabledReason = {}

        NewUserWithDisabledReason = Object.assign({}, newUser, {
            disabled_reason: reason,
        })

        // console.log(
        //     ' from  setUserIsDisabled   NewUserWithDisabledReason = ',
        //     NewUserWithDisabledReason
        // )

        api.saveUser(NewUserWithDisabledReason).subscribe(
            (res) => {
                setShowDoneModal(true)
            },
            (error) => console.log('disable user error', error)
        )
    }

    const onCloseDoneModal = () => {
        history.goBack()
    }

    return (
        <Container>
            <SubmitButton
                onClick={() => setShowConfirmModal(true)}
                label={texts[action].btnText}
                theme={user.is_disabled ? 'white' : 'dark'}
            />

            <ConfirmModal
                isOpen={showConfirmModal}
                title={texts[action].btnText}
                mainText={texts[action].confirmMainText}
                onConfirm={setUserIsDisabled}
                onCancel={() => setShowConfirmModal(false)}
                withTextInput={!user.is_disabled}
                textInputLabel={'סיבת החסימה'}
                textInputValue={reason || ''}
                onChangeTextInput={setReason}
                textInputRequired={true}
            />
            <MessageModal
                isOpen={showDoneModal}
                title={'הפעולה בוצעה בהצלחה'}
                mainText={''}
                onClose={onCloseDoneModal}
            />
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
`
